export const mapStyles = [
  { label: "light", url: "mapbox://styles/mapbox/light-v10" },
  { label: "dark", url: "mapbox://styles/mapbox/dark-v10" },
  {
    label: "Real",
    url: "mapbox://styles/mapbox-map-design/ckhqrf2tz0dt119ny6azh975y",
  },
];
